<template lang="pug">
  date-picker(
    v-model='model'
    :name='name'
    :ref-name='refName'
    :id='id'
    :format='format'
    :lang='language'
    :disabled='disabled'
    :placeholder='placeholder'
    :input-class='inputClass'
    :required='required'
    :editable='editable'
    v-bind="$attrs"
  )
</template>
<script>
import DatePicker from 'vue2-datepicker'
import { isDate } from 'paliari-js-utils'
import 'vue2-datepicker/locale/pt-br'

export default {
  components: { DatePicker },
  props: {
    value: { required: true },
    name: String,
    refName: String,
    id: String,
    format: {
      default: 'DD/MM/YYYY',
    },
    language: {
      type: String,
      default: 'pt-BR',
    },
    disabled: Boolean,
    placeholder: String,
    inputClass: { type: String, default: 'form-input' },
    required: Boolean,
    editable: { type: Boolean, default: true },
    fullDay: { type: Boolean, default: false },
  },
  computed: {
    model: {
      get() {
        const value = new Date(this.value)
        const offset = value.getTimezoneOffset()
        return new Date(value.getTime() + offset * 60 * 1000)
      },
      set(v) {
        if (isDate(v)) {
          const offset = new Date().getTimezoneOffset()
          const utcDate = new Date(v.getTime() - offset * 60 * 1000)

          if (this.fullDay) {
            utcDate.setUTCHours(23, 59, 59, 999)
          }

          this.$emit('input', utcDate.toJSON())
        }
      },
    },
  },
}
</script>

<style lang="stylus">
.mx-datepicker
  display block
  width 100% !important
</style>
